import { SubscriptionPlans } from './subscription-plans';

/** True when `planCode` is the explicit Free tier (not Starter). */
export function isFreePlan(planCode: string | undefined): boolean {
  if (!planCode) {
    return false;
  }

  return planCode.toLowerCase() === SubscriptionPlans.FREE;
}

/**
 * Returns true when the subscription tier is treated as locked for Growth-style upsells:
 * explicitly **Free**, or any plan code containing **Starter** (any billing cadence).
 *
 * Pair with `/user/meta` `resources[]` (`useHasMetaResources`: id present ⇒ enabled) — this
 * is only the **planCode** slice from `home.subscription`.
 */
export function isFreeOrStarterPlan(planCode: string | undefined): boolean {
  if (!planCode) {
    return false;
  }

  const normalized = planCode.toLowerCase();

  if (normalized === SubscriptionPlans?.FREE) {
    return true;
  }

  return normalized.includes('starter');
}
